import Button from '@components/Button';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { RecentOrderRow } from '@models/order';
import { useFlow } from '@stackflow/react';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

import useDoRecentOrder from './hooks/useDoRecentOrder';

interface Props {
    order: RecentOrderRow;
}

function RecentOrderItem({ order }:Props) {
    const {
        orderName, orderItems, shopName, orderNo,
    } = order;
    const { t } = useTranslation('main', { keyPrefix: 'recentOrders' });
    const thumbnail = orderItems?.[0]?.thumbNailImageUrl;
    const optionStr = orderItems?.[0]?.options
        ?.map((it) => `${it.optionName}(${it.qty}${t('unit')})`)
        .sort().join(', ');
    const handleOrder = useDoRecentOrder(order);
    const { push } = useFlow();
    return (
        <Container>
            <Row fullWidth onClick={() => push('OrderLogActivity', { orderNo })}>
                <ThumbnailWrapper>
                    <Image width={80}
                        height={80}
                        src={thumbnail} />
                </ThumbnailWrapper>
                <Column spacing={8}>
                    <Text color={colors.gray9} fontWeight='medium'>
                        {orderName}
                    </Text>
                    <Text color={colors.gray7} size='s'>{optionStr}</Text>
                </Column>
            </Row>
            <Footer>
                <Text color={colors.gray6} size='s'>
                    {shopName}
                </Text>
                <OrderButton variant='sub-outline' size='sm' onClick={handleOrder}>
                    {t('order')}
                </OrderButton>
            </Footer>
        </Container>
    );
}

const Container = styled.div`
    background-color: ${colors.gray1};
    border-radius: 8px;
    width: calc(100vw - 60px);
    min-width: calc(100vw - 60px);
    scroll-snap-stop: always;
    scroll-snap-align: start;
    ${pressActionEffect}
`;

const ThumbnailWrapper = styled.div`
    padding: 16px;
`;

const Footer = styled.div`
    border-top: 1px solid ${colors.gray2};
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const OrderButton = styled(Button)`
    padding: 5.5px 12px;
    height: unset !important;
    font-size: 12px !important;
`;

export default RecentOrderItem;
